/* eslint-disable operator-linebreak */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-parens */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { Creators as AdActions } from "~/redux/ducks/ad";

import Checkbox from "~/Components/Checkbox";
import Modal from "~/Components/Modal";
import ColorPicker from "../ColorPicker";
import { SelectStyled } from "~/Components/Styled";
import Button from "~/Components/Button";

import {
  Row,
  FormGroupColumnLeft,
  FormGroupColumnRight,
  FormGroup,
  Input,
  ButtonAddProperty,
  ButtonDeleteProperty,
  RowFooter,
  ButtonCancel
} from "./styles";

const ModalNew = props => {
  const {
    createAd,
    // change modal status
    changeModalNewAd,
    // select filter partner
    advertisingPartnerList,
    // select filter event
    eventsList,
    // select filter channel
    channelsList,
    // state new ad
    adNew,
    changeStateNewAd,
    addNewFieldPropertyOnNewAd,
    deleteFieldPropertyOnNewAd,
    changePropertyStateNewAd,
    adList
  } = props;
  let channels = adList.filter(
    item => parseInt(item.eventId) === parseInt(adNew.event)
  );
  channels = channels.map(item =>
    channelsList.find(channel => channel.code === item.channel)
  );

  return (
    <Modal width={650}>
      <>
        <Row>
          <h1>Cadastro de anúncio</h1>
        </Row>
        <Row>
          <FormGroupColumnLeft>
            <Checkbox
              label="Habilitado"
              value={adNew.enabled}
              onChange={value => {
                changeStateNewAd({
                  enabled: value
                });
              }}
            />
          </FormGroupColumnLeft>
          <FormGroupColumnRight>
            <label>Cor</label>
            <ColorPicker
              value={adNew.color}
              onChange={value => {
                changeStateNewAd({
                  color: value
                });
              }}
            />
          </FormGroupColumnRight>
        </Row>
        <Row>
          <FormGroup>
            <label>Descrição</label>
            <Input
              value={adNew.label}
              placeholder="Descrição"
              onChange={e => {
                changeStateNewAd({
                  label: e.target.value
                });
              }}
            />
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <label>Fornecedor</label>
            <SelectStyled
              defaultValue={adNew.partner}
              onChange={e => {
                changeStateNewAd({
                  partner: e.target.value
                });
              }}
            >
              <option value="">Fornecedor...</option>
              {advertisingPartnerList.map(item => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </SelectStyled>
          </FormGroup>
        </Row>
        <Row>
          <FormGroupColumnLeft>
            <label>Evento</label>
            <SelectStyled
              defaultValue={adNew.event}
              onChange={e => {
                changeStateNewAd({
                  event: e.target.value
                });
              }}
            >
              <option value="">Evento...</option>
              {eventsList.map(item => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </SelectStyled>
          </FormGroupColumnLeft>
          <FormGroupColumnRight>
            <label>Canal</label>
            <SelectStyled
              defaultValue={adNew.channel}
              onChange={e => {
                changeStateNewAd({
                  channel: e.target.value
                });
              }}
            >
              <option value="">Canal...</option>
              {channels.map(item => (
                <option key={item.id} value={item.code}>
                  {item.name}
                </option>
              ))}
            </SelectStyled>
          </FormGroupColumnRight>
        </Row>
        <Row>
          <FormGroup>
            <label>Propriedades</label>
          </FormGroup>
          <ButtonAddProperty
            title="Nova Propriedade"
            bordered
            onClick={() => {
              addNewFieldPropertyOnNewAd();
            }}
          />
        </Row>
        <div>
          {adNew.properties.map((property, index) => (
            <Row key={index}>
              <FormGroupColumnLeft>
                <label>Chave</label>
                <Input
                  value={property.key}
                  placeholder="Chave"
                  onChange={e => {
                    changePropertyStateNewAd(index, {
                      key: e.target.value
                    });
                  }}
                />
              </FormGroupColumnLeft>
              <FormGroupColumnRight>
                <label>Valor</label>
                <Input
                  value={property.value}
                  placeholder="Valor"
                  onChange={e => {
                    changePropertyStateNewAd(index, {
                      value: e.target.value
                    });
                  }}
                />
              </FormGroupColumnRight>
              <ButtonDeleteProperty
                bordered
                title="Excluir"
                onClick={() => {
                  deleteFieldPropertyOnNewAd(index);
                }}
              />
            </Row>
          ))}
        </div>
        <RowFooter>
          <ButtonCancel
            color="light"
            title="CANCELAR"
            onClick={() => changeModalNewAd(false)}
          />
          <Button
            title="CONFIRMAR"
            disabled={
              !adNew.label || !adNew.partner || !adNew.event || !adNew.channel
            }
            onClick={() => {
              createAd();
            }}
          />
        </RowFooter>
      </>
    </Modal>
  );
};

ModalNew.propTypes = {
  // State
  adList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  channelsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  eventsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  advertisingPartnerList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  adNew: PropTypes.shape().isRequired,
  // Functions
  changeStateNewAd: PropTypes.func.isRequired,
  addNewFieldPropertyOnNewAd: PropTypes.func.isRequired,
  deleteFieldPropertyOnNewAd: PropTypes.func.isRequired,
  changePropertyStateNewAd: PropTypes.func.isRequired,
  createAd: PropTypes.func.isRequired,
  changeModalNewAd: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  adList: state.ad.adList,
  adNew: state.ad.adNew,
  channelsList: state.channel.channelsList,
  eventsList: state.event.eventsList,
  advertisingPartnerList: state.advertisingPartner.advertisingPartnerList
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createAd: AdActions.createAd,
      changeStateNewAd: AdActions.changeStateNewAd,
      addNewFieldPropertyOnNewAd: AdActions.addNewFieldPropertyOnNewAd,
      deleteFieldPropertyOnNewAd: AdActions.deleteFieldPropertyOnNewAd,
      changePropertyStateNewAd: AdActions.changePropertyStateNewAd,
      changeModalNewAd: AdActions.changeModalNewAd
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalNew);
